module.exports = __webpack_public_path__ + "img/ft1.9008b5bd.png";